<ng-container *ngIf="!loadingUserData">
  <div class="user-lists">
    <opac-user-title [title]="'lists.title' | translate"></opac-user-title>
    <mat-tab-group
      class="user-lists__content"
      animationDuration="0ms"
      disableRipple="true"
      [preserveContent]="true"
      [selectedIndex]="selectedTabIndex"
      (selectedIndexChange)="tabChanged($event)">
      <mat-tab label="{{ 'lists.listsTab' | translate }}">
        <opac-button *ngIf="userService.lists.length > 0" class="create-list-button" (click)="openCreateListModal()"
          >{{ 'lists.create.label' | translate }}</opac-button
        >

        <div class="user-lists__sliders-wrapper">
          <app-slider-favourites
            *ngIf="(isLoading$ | async) === false"
            [paginatedFavorites]="paginatedFavorites$ | async"
            [preview]="true"></app-slider-favourites>

          <opac-user-section
            *ngIf="userService.lists.length === 0"
            [title]="'lists.title' | translate">
            <opac-no-results-cta>
              {{ 'lists.create.text' | translate }}
              <opac-button type="secondary" (click)="openCreateListModal()">
                {{ 'lists.create.label' | translate }}
              </opac-button>
            </opac-no-results-cta>
          </opac-user-section>

          <ng-container *ngFor="let list of userService.lists; index as i">
            <app-slider-list [list]="list" [preview]="true" [collection]="{ id: list.id }"></app-slider-list>
          </ng-container>
        </div>
      </mat-tab>

      <mat-tab label="{{ 'lists.followsTab' | translate }}">
        <ng-container *ngIf="!loadingFollowings">
          <div class="user-lists__sliders-wrapper">
            <app-slider-authors
              [title]="'user.lists.authors' | translate"
              [authors]="userService.followedAuthors"></app-slider-authors>

            <ng-container *ngFor="let subscription of listFollowings.items">
              <app-slider-list
                [list]="subscription.list"
                [forListSubscriptions]="true"
                [collection]="{ id: subscription.list.id }"></app-slider-list>
            </ng-container>

            <opac-user-section
              *ngIf="listFollowings.items.length === 0"
              [title]="'lists.following.ctaTitle' | translate">
              <opac-no-results-cta>
                {{ 'lists.noFollowedLists' | translate }}
                <opac-button type="secondary" (click)="exploreLists()">
                  {{ 'lists.exploreListsCta' | translate }}
                </opac-button>
              </opac-no-results-cta>
            </opac-user-section>
          </div>

          <mat-paginator
            *ngIf="listFollowings && listFollowings.itemsTotal > 10"
            [length]="listFollowings.itemsTotal"
            [pageSize]="listFollowings.itemsPerPage"
            [pageSizeOptions]="pageSizeOptions"
            [showFirstLastButtons]="true"
            (page)="pageChangeHandler($event)"></mat-paginator>
        </ng-container>

        <ng-container *ngIf="loadingFollowings">
          <!-- FIXME this style is because angular 16 migration. Tab component no longer has bottom spacing so I need to include it in every component manually -->
          <lists-skeleton style="display: block; margin-top: 24px" [showTabs]="false"></lists-skeleton>
          <opac-gradient></opac-gradient>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
  </div>
</ng-container>

<ng-container *ngIf="loadingUserData">
  <lists-skeleton></lists-skeleton>
  <opac-gradient></opac-gradient>
</ng-container>
